// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AccountSeal;
(function (AccountSeal) {
    AccountSeal[AccountSeal["Unspecified"] = -1] = "Unspecified";
    AccountSeal[AccountSeal["Demo"] = 0] = "Demo";
    AccountSeal[AccountSeal["Live"] = 1] = "Live";
    AccountSeal[AccountSeal["Contest"] = 2] = "Contest";
    AccountSeal[AccountSeal["Funded"] = 3] = "Funded";
    AccountSeal[AccountSeal["Challenge"] = 4] = "Challenge";
})(AccountSeal || (AccountSeal = {}));
const AccountSealLocalizationKeys = {
    [AccountSeal.Unspecified]: 'Accounts.AccountDetails.Mode.Demo',
    [AccountSeal.Demo]: 'Accounts.AccountDetails.Mode.Demo',
    [AccountSeal.Live]: 'Accounts.AccountDetails.Mode.Live',
    [AccountSeal.Contest]: 'Accounts.AccountDetails.Mode.Contest',
    [AccountSeal.Funded]: 'Accounts.AccountDetails.Mode.Funded',
    [AccountSeal.Challenge]: 'Accounts.AccountDetails.Mode.Challenge'
};
export function getAccountSealLocalizationKey(accountSeal) {
    return AccountSealLocalizationKeys[accountSeal];
}
export var AccountVisibilityType;
(function (AccountVisibilityType) {
    AccountVisibilityType[AccountVisibilityType["VISIBILITY_FLAG_OWN"] = 1] = "VISIBILITY_FLAG_OWN";
    AccountVisibilityType[AccountVisibilityType["VISIBILITY_FLAG_GROUP"] = 2] = "VISIBILITY_FLAG_GROUP";
    AccountVisibilityType[AccountVisibilityType["VISIBILITY_FLAG_LINK"] = 4] = "VISIBILITY_FLAG_LINK";
    AccountVisibilityType[AccountVisibilityType["VISIBILITY_FLAG_MAM"] = 8] = "VISIBILITY_FLAG_MAM"; // - видимость по мам группе
})(AccountVisibilityType || (AccountVisibilityType = {}));
